import UserPage from '../views/UserManagement';
import RecordGroupPage from '../views/RecordGroup';
import RecordPage from '../views/Record';
import PolicyPage from '../views/Policy';

const privateRoutes = [
  {
    name: 'Policy',
    path: '/policy',
    component: PolicyPage,
    exact: false,
  },
  {
    name: 'User Management',
    path: '/user-management',
    component: UserPage,
    exact: true,
  },
  {
    name: 'RecordGroup Detail',
    path: '/user-management/:userId',
    component: RecordGroupPage,
    exact: false,
  },
  {
    name: 'Record Detail',
    path: '/records/:groupId',
    component: RecordPage,
    exact: false,
  },
  {
    path: '/',
    redirect: true,
    pathTo: '/user-management',
  },
];

export default privateRoutes;
